import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierPublicationInfosController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierPublicationInfosController.php
* @route '/api/dossier/{dossier}/site-infos'
*/
const UpdateDossierPublicationInfosController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierPublicationInfosController.url(args, options),
    method: 'put',
})

UpdateDossierPublicationInfosController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/site-infos',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierPublicationInfosController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierPublicationInfosController.php
* @route '/api/dossier/{dossier}/site-infos'
*/
UpdateDossierPublicationInfosController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierPublicationInfosController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierPublicationInfosController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierPublicationInfosController.php
* @route '/api/dossier/{dossier}/site-infos'
*/
UpdateDossierPublicationInfosController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierPublicationInfosController.url(args, options),
    method: 'put',
})

export default UpdateDossierPublicationInfosController